export default "__VITE_ASSET__CXyNaE3x__"